import * as tslib_1 from "tslib";
import Vue from "vue";
import Component from "vue-class-component";
import { Card, Checkbox, Button } from "@/components/UIComponents";
import { UserAuthenticationResponse } from "@/API/Models/Authentication/UserAuthenticationResponse";
import { AuthenticationDAO } from "@/API/DAO/AuthenticationDAO";
import swal from 'sweetalert2';
let NewLoginViewModel = class NewLoginViewModel extends Vue {
    constructor() {
        super();
        this.email = "";
        this.username = "";
        this.password = "";
        this.email = "";
        this.username = "";
        this.password = "";
        this.sessionDataKey = "";
        this.redirectUrl = "";
        this.authenticationResponse = new UserAuthenticationResponse();
        this.authError = false;
        this.authErrorMessage = '';
    }
    onPasswordChange(event) {
        console.log("Updating error to false");
        this.authError = false;
    }
    closeMenu() {
        document.body.classList.remove("nav-open");
        document.body.classList.remove("off-canvas-sidebar");
    }
    get validInput() {
        return this.$validator.validateAll().then(res => {
            console.log("Validation response: " + res);
            return res;
        });
    }
    getError(fieldName) {
        return this.$validator.errors.first(fieldName);
    }
    get emailValidation() {
        return {
            email: true,
            required: true,
            min: 2
        };
    }
    get passwordValidation() {
        return {
            required: true,
            min: 2
        };
    }
    get isIdentityRedirected() {
        let fromIdentityServer = false;
        if (this.sessionDataKey != undefined && this.sessionDataKey.length > 0) {
            fromIdentityServer = true;
        }
        return fromIdentityServer;
    }
    get identityServerRedirectUrl() {
        let redirectUrl = "";
        if (this.authenticationType === "samlsso") {
            redirectUrl = this.idpBaseUrl + "/samlsso";
        }
        else if (this.authenticationType === "oauth2") {
            redirectUrl = this.idpBaseUrl + "/oauth2/authorize";
        }
        else {
            redirectUrl = this.idpBaseUrl + "/commonauth";
        }
        return redirectUrl;
    }
    get idpBaseUrl() {
        return process.env.VUE_APP_IDP_BASE_URL;
    }
    async forgotPassword() {
        this.$router.push({ name: "IdentityRecoveryPassword", query: this.$route.query });
    }
    async resendConfirmation() {
        try {
            await AuthenticationDAO.resendAccountConfirmation(this.email);
            await swal.fire({
                title: `Confirmation Resent`,
                text: `We have sent instructions on how to reset your password to ` + this.email,
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-info btn-fill'
            });
            this.$router.push({ name: 'IdentityNewLogin', query: this.$route.query });
        }
        catch (error) {
            await swal.fire({
                title: `Resend Confirmation Failed`,
                text: JSON.stringify(error),
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-info btn-fill'
            });
        }
    }
    async signIn() {
        if (await this.validInput == true) {
            let authResponse = await AuthenticationDAO.authenticateUser(this.email, this.password, this.$route.fullPath);
            console.log('Auth Response: ' + JSON.stringify(authResponse));
            if (authResponse.successful === true) {
                if (process.env.VUE_APP_ENV != "DEV") {
                    const usernameInput = document.getElementById("username");
                    usernameInput.value = authResponse.username;
                    const passwordInput = document.getElementById("password");
                    passwordInput.value = this.password;
                    const sessionDataKeyInput = document.getElementById("sessionDataKey");
                    sessionDataKeyInput.value = this.sessionDataKey;
                    const signupForm = document.getElementById("signupForm");
                    signupForm.action = this.identityServerRedirectUrl;
                    signupForm.submit();
                }
                else {
                    console.log('Authenticated Successfully...');
                }
            }
            else {
                this.authErrorMessage = authResponse.message;
                this.authError = true;
            }
        }
    }
    beforeCreate() {
        let redirect = false;
        /*
          -If not in local development mode....
          --Let's test to make sure we have a valid login request and not local development
        */
        if (process.env.VUE_APP_ENV != "DEV") {
            if (this.$route.query.type === "samlsso") {
                redirect = false;
            }
            else if (this.$route.query.oauthErrorCode != undefined && this.$route.query.oauthErrorCode === "invalid_callback") {
                redirect = true;
            }
            else if (this.$route.query.sp === undefined || this.$route.query.sp === null) {
                redirect = true;
            }
            else if (this.$route.query.client_id === undefined || this.$route.query.client_id === null) {
                redirect = true;
            }
            else if (this.$route.query.redirect_uri === undefined || this.$route.query.redirect_uri === null) {
                redirect = true;
            }
            if (redirect === true) {
                // @ts-ignore
                window.location = process.env.VUE_APP_CONFIGIO_URL + "/login?ReturnURL=%2FShoppingCart.aspx";
            }
        }
    }
    mounted() {
        this.sessionDataKey = this.$route.query.sessionDataKey;
        this.authenticationType = this.$route.query.type;
    }
    beforeDestroy() {
        this.closeMenu();
    }
};
NewLoginViewModel = tslib_1.__decorate([
    Component({
        components: {
            [Card.name]: Card,
            [Checkbox.name]: Checkbox,
            [Button.name]: Button
        }
    })
], NewLoginViewModel);
export default NewLoginViewModel;
